import { useQuery } from '@tanstack/react-query';
import api from '../utils/api';

export const MIN_SEARCH_CHARS = 2;

// Full-text search inside journal entries. Runs on the server because every
// body is encrypted under the user's key — the sidebar index only carries a
// short snippet, which is why matching against it missed words deeper in an
// entry. Callers debounce; react-query aborts the superseded request via
// `signal`, so fast typing never lets an older response win.
export function useJournalSearch(userId, query) {
  const q = (query || '').trim();
  return useQuery({
    queryKey: ['journal-search', userId, q],
    enabled: !!userId && [...q].length >= MIN_SEARCH_CHARS,
    queryFn: async ({ signal }) => {
      const res = await api.get(`/user/${userId}/journal/search`, {
        params: { q },
        signal,
      });
      return res.data;
    },
    staleTime: 30_000,
    retry: 1,
    refetchOnWindowFocus: false,
  });
}
